module.exports = __webpack_public_path__ + "static/media/gallery_mockup.b6b2ab7a.png";